export const translations = {
  nav: {
    brand: "Seaing You",
    products: "产品",
    cart: "购物车",
    profile: "个人中心",
    signIn: "登录",
    signOut: "退出",
    adminPanel: "管理面板",
  },
  
  footer: {
    contact: "联系我们",
    privacyPolicy: "隐私政策",
    termsOfUse: "使用条款",
    copyright: "版权所有。",
    kvk: "KVK",
  },
  
  landing: {
    title: "Seaing You",
    subtitle: "新鲜海鲜，送达您身边",
    description: "订购优质小龙虾和大闸蟹，在便利地点自取。选择您的取货日期，挑选产品，享受最新鲜的海鲜。",
    orderNow: "立即订购",
    signIn: "登录",
    myProfile: "我的账户",
  },
  
  products: {
    title: "我们的产品",
    subtitle: "浏览我们的新鲜海鲜选择。点击产品查看可用的取货日期并下单。",
    viewDetails: "查看详情",
    noProducts: "目前没有可用的产品。",
    perKg: "每公斤",
    inclVat: "含税",
    loadingError: "加载产品失败。请稍后再试。",
  },
  
  productDetail: {
    backToProducts: "返回产品页面",
    selectPickupLocationDate: "选择取货地点和日期",
    noPickupDates: "此产品目前暂无可用的取货日期。",
    minimumOrder: "最低订购量",
    orderIncrement: "订购增量",
    datesAvailable: "个日期",
    datesAvailablePlural: "个日期",
    available: "可用",
    availablePickupDates: "可用取货日期：",
    orderBy: "下单截止",
    orderDetails: "订单详情",
    quantityKg: "数量（公斤）",
    quantityPlaceholder: "最低：{min} 公斤",
    quantityPlaceholderWithIncrement: "最低：{min} 公斤，增量：{increment} 公斤",
    subtotal: "小计",
    addToCart: "加入购物车",
    viewCart: "查看购物车",
    addedToCart: "已加入购物车！",
    selectDateError: "请选择取货日期",
    quantityRequiredError: "请输入数量",
    quantityPositiveError: "数量必须大于0",
    quantityMinError: "最低订购量为 {min} 公斤",
    quantityIncrementError: "数量必须以 {increment} 公斤为增量（例如：{min}、{example1}、{example2}...）",
    quantityExceedsError: "仅有 {max} 公斤可用",
    quantityInvalidError: "请输入有效的数量",
    dateNoLongerAvailable: "所选取货日期已不可用",
    loadingError: "加载产品详情失败。请稍后再试。",
  },
  
  cart: {
    title: "您的购物车",
    empty: "您的购物车是空的",
    browseProducts: "浏览产品",
    pickup: "取货",
    location: "地点",
    quantityKg: "数量（公斤）",
    remove: "移除",
    continueShopping: "继续购物",
    orderSummary: "订单摘要",
    items: "商品",
    subtotalExclVat: "小计（不含税）",
    vat: "税费（9%）",
    totalInclVat: "总计（含税）",
    proceedToCheckout: "前往结账",
    quantityPositive: "数量必须大于0",
    quantityExceeds: "仅有 {max} 公斤可用",
    cartEmpty: "您的购物车是空的",
    fixErrors: "请在继续之前修正数量错误",
  },
  
  checkout: {
    title: "结账",
    customerInformation: "客户信息",
    name: "姓名",
    email: "邮箱",
    phone: "电话",
    address: "地址",
    required: "*",
    nameRequired: "姓名为必填项",
    emailRequired: "邮箱为必填项",
    emailInvalid: "邮箱格式无效",
    phoneRequired: "电话为必填项",
    addressRequired: "地址为必填项",
    termsRequired: "您必须接受条款才能继续",
    cancellationPolicyRequired: "您必须确认取消政策才能继续",
    termsText: "我理解如果我在取货时间窗口内未到场，我的订单将被丢弃且不予退款。",
    cancellationPolicyText: "我确认在所选取货日期的最后下单日期之后，订单无法取消，因为所有产品都是新鲜的，并根据确认的订单数量采购。",
    continueToPayment: "继续支付",
    orderSummary: "订单摘要",
    pickupDetails: "取货详情",
    dateTime: "日期和时间",
    location: "地点",
    items: "商品",
    cartEmpty: "您的购物车是空的。正在跳转...",
    subtotalExclVat: "小计（不含税）",
    vat: "税费（9%）",
    totalInclVat: "总计（含税）",
  },
  
  payment: {
    title: "支付",
    completePayment: "完成支付",
    customerInformation: "客户信息",
    name: "姓名",
    email: "邮箱",
    phone: "电话",
    address: "地址",
    pickupDetails: "取货详情",
    dateTime: "日期和时间",
    location: "地点",
    items: "商品",
    subtotalExclVat: "小计（不含税）",
    vat: "税费（9%）",
    totalAmount: "总金额（含税）",
    reminderTitle: "提醒：",
    reminderText: "继续支付即表示您确认理解，如果您在取货时间窗口内未到场，您的订单将被丢弃且不予退款。",
    proceedToPayment: "继续支付",
    processing: "处理中...",
    backToCheckout: "返回结账",
    loading: "加载中...",
    createOrderError: "创建订单失败",
    paymentInitError: "初始化支付失败",
  },
  
  paymentReturn: {
    verifying: "正在验证支付...",
    verifyingMessage: "请稍候，我们正在确认您的支付。",
    success: "支付成功！",
    successMessage: "您的{count}已确认。感谢您的购买！",
    successMessageSingle: "订单",
    successMessagePlural: "订单",
    failure: "支付失败",
    failureMessage: "无法处理您的支付。",
    orderDetails: "订单 {number} 详情",
    orderId: "订单编号",
    orderDate: "下单日期",
    totalAmount: "总金额",
    status: "状态",
    pickupInformation: "取货信息",
    dateTime: "日期和时间",
    location: "地点",
    itemsOrdered: "订购商品",
    customerInformation: "客户信息",
    name: "姓名",
    email: "邮箱",
    phone: "电话",
    address: "地址",
    importantTitle: "重要提示：",
    importantText: "请在预定的取货时间窗口内到达取货地点。如果您未到场，您的订单将被丢弃且不予退款。",
    placeAnotherOrder: "再次下单",
    returnToHome: "返回首页",
    returnToCart: "返回购物车",
    noSessionId: "未找到会话ID",
    paymentNotCompleted: "支付未完成。请重试。",
    paymentFailed: "支付失败。请重试。",
  },
  
  profile: {
    title: "我的账户",
    loading: "正在加载您的账户...",
    loadError: "加载账户失败。请稍后再试。",
    accountInformation: "账户信息",
    name: "姓名",
    email: "邮箱",
    phone: "电话",
    memberSince: "注册时间",
    notProvided: "未提供",
    unknown: "未知",
    orderHistory: "订单历史",
    noOrders: "您还没有下过订单。",
    placeFirstOrder: "下第一单",
    orderNumber: "订单 #",
    placedOn: "下单时间",
    pickupDetails: "取货详情",
    dateTime: "日期和时间",
    location: "地点",
    items: "商品",
    paidOn: "支付时间：",
    reminderTitle: "提醒：",
    reminderText: "请在预定的取货时间内到达取货地点。迟到可能导致订单被取消且不予退款。",
    statusPaid: "已支付",
    statusPending: "待处理",
    statusCompleted: "已完成",
    statusCancelled: "已取消",
  },
  
  contact: {
    title: "联系我们",
    intro: "我们很乐意听到您的声音！请随时通过以下任何方式与我们联系：",
    email: "邮箱",
    phone: "电话",
    wechat: "微信",
    wechatDescription: "扫描二维码添加我们",
    wechatQrAlt: "微信二维码",
  },
  
  terms: {
    title: "使用条款",
    lastUpdated: "最后更新：",
    section1Title: "1. 接受条款",
    section1Content: "通过访问和使用本网站，您接受并同意受本协议条款和规定的约束。如果您不同意这些条款，请不要使用本网站。",
    section2Title: "2. 服务使用",
    section2Content: "您同意仅出于合法目的并按照本使用条款使用我们的服务。您被禁止：",
    section2Item1: "以任何违反适用法律或法规的方式使用服务",
    section2Item2: "试图干扰服务的正常运行",
    section2Item3: "从事任何欺诈活动",
    section2Item4: "冒充他人或实体",
    section3Title: "3. 订单和付款",
    section3Content: "所有新鲜食品订单可以通过联系客服取消，最迟在您取货日期列出的最后下单日期之前。在此日期之后，产品已经订购，订单无法取消。",
    section4Title: "4. 产品信息",
    section4Content: "我们努力提供准确的产品描述和图片。但是，我们不保证网站上的产品描述、图片或其他内容准确、完整、可靠、最新或无错误。",
    section5Title: "5. 取货和配送",
    section5Content: "订单必须在预定的时间和地点取货。我们不对在指定时间范围内未取货的订单负责。如果您无法按时到达取货地点，请联系我们，但我们无法保证能够配送您的订单。",
    section6Title: "6. 责任限制",
    section6Content: "在法律允许的最大范围内，Seaing You 不对因您使用或无法使用服务而导致的任何间接、附带、特殊、后果性或惩罚性损害承担责任。",
    section7Title: "7. 条款变更",
    section7Content: "我们保留随时修改这些条款的权利。变更将在发布到网站后立即生效。在发布变更后继续使用服务即表示接受修改后的条款。",
    section8Title: "8. 联系信息",
    section8Content: "如有关于本使用条款的问题，请通过 seaingyou@outlook.com 联系我们",
  },
  
  privacy: {
    title: "隐私政策",
    lastUpdated: "最后更新：",
    section1Title: "1. 我们收集的信息",
    section1Content: "我们收集您直接提供给我们的信息，包括当您创建账户、下订单或联系我们寻求支持时。这可能包括您的姓名、电子邮箱地址、电话号码、配送地址和付款信息。",
    section2Title: "2. 我们如何使用您的信息",
    section2Content: "我们使用收集的信息来：",
    section2Item1: "处理和履行您的订单",
    section2Item2: "与您沟通有关您的订单和我们的服务",
    section2Item3: "改进我们的产品和服务",
    section2Item4: "向您发送营销信息（经您同意）",
    section2Item5: "遵守法律义务",
    section3Title: "3. 信息共享",
    section3Content: "我们不会向第三方出售或出租您的个人信息。我们可能会在严格的保密协议下与协助我们运营业务的服务提供商（如支付处理商和配送服务）共享您的信息。",
    section4Title: "4. 数据安全",
    section4Content: "我们实施适当的技术和组织措施，以保护您的个人信息免遭未经授权的访问、更改、披露或破坏。",
    section5Title: "5. 您的权利",
    section5Content: "您有权访问、更正或删除您的个人信息。您还可以反对或限制对您数据的某些处理。要行使这些权利，请使用我们联系页面上提供的信息与我们联系。",
    section6Title: "6. 联系我们",
    section6Content: "如果您对本隐私政策有任何疑问，请通过 seaingyou@outlook.com 联系我们",
  },
  
  orderSummary: {
    title: "订单摘要",
    pickupDetails: "取货详情",
    dateTime: "日期和时间",
    location: "地点",
    items: "商品",
    noItems: "订单中没有商品",
    subtotalExclVat: "小计（不含税）",
    vat: "税费（9%）",
    totalInclVat: "总计（含税）",
  },
  
  customerInfoForm: {
    name: "姓名",
    email: "邮箱",
    phone: "电话",
    address: "地址",
    required: "*",
    namePlaceholder: "请输入您的全名",
    emailPlaceholder: "your.email@example.com",
    phonePlaceholder: "+31 6 12345678",
    addressPlaceholder: "街道、城市、邮政编码",
  },
  
  productCard: {
    price: "价格",
    perKg: "每公斤",
    available: "可用",
    quantityKg: "数量（公斤）",
    outOfStock: "缺货",
  },
  
  termsCheckbox: {
    acceptTerms: "我接受",
    termsOfUse: "使用条款",
    and: "和",
    privacyPolicy: "隐私政策",
  },
  
  loading: {
    message: "加载中...",
  },
  
  error: {
    generic: "发生错误。请重试。",
    tryAgain: "重试",
  },
  
  common: {
    kg: "公斤",
    perKg: "每公斤",
    inclVat: "含税",
    exclVat: "不含税",
    vat: "税费",
    total: "总计",
    subtotal: "小计",
    cancel: "取消",
    confirm: "确认",
    save: "保存",
    edit: "编辑",
    delete: "删除",
    back: "返回",
    next: "下一步",
    submit: "提交",
    close: "关闭",
    yes: "是",
    no: "否",
    from: "从",
    to: "到",
  },
} as const;

export type TranslationKeys = typeof translations;
